angular.module('impactx.toast').service('ToastService', ['$mdToast', '$workspaceIdHolder', ToastService]);

function ToastService($mdToast, $workspaceIdHolder) {
    var uploadProgress = 0;
    this.uploadToastPromise = {};

    /**
     * Opens a standard toast with only label on it.
     *
     * @param translation label on the toast
     */
    this.openStandardToast = function (translation) {
        return $mdToast.show(
            $mdToast.simple()
                .textContent(translation)
                .position("bottom right")
                .hideDelay(10000)
                .theme($workspaceIdHolder.currentWorkspaceId.value)
        );
    };

    /**
     * Opens a standard toast after successful save operation.
     *
     * @param translationScope scope of the controller
     * @param backendData data from backend.
     */
    this.openStandardToastAfterSaveSuccess = function (translationScope, backendData) {
        var message = '';

        if (translationScope && translationScope.trns) {
            message = translationScope.trns.saveSuccess;
        }

        if (impactX.isDefined(backendData, 'data.message')) {
            //custom message
            message = backendData.data.message;
        }

        $mdToast.show(
            $mdToast.simple()
                .textContent(message)
                .position("bottom right")
                .hideDelay(10000)
        );
        //No theme!
    };

    /**
     * Opens a standard toast after successful delete operation.
     *
     * @param translationScope scope of the controller
     * @param backendData data from backend.
     */
    this.openStandardToastAfterDeleteSuccess = function (translationScope, backendData) {
        var message = '';

        if (translationScope && translationScope.trns) {
            message = translationScope.trns.deleteSuccess;
        }

        if (impactX.isDefined(backendData, 'data.message')) {
            //custom message
            message = backendData.data.message;
        }

        $mdToast.show(
            $mdToast.simple()
                .textContent(message)
                .position("bottom right")
                .hideDelay(10000)
        );
        //No theme!
    };

    /**
     * Opens a toast with a action button.
     *
     * @param translation text content of the toast
     * @param actionName name of the action button
     * @param actionFunc function of which will be called when the button is clicked
     * @param hideFunc function of which will be called when the toast hides without button press
     * @param actionParams params for action function
     */
    this.openActionToast = function (translation, actionName, actionFunc, hideFunc, actionParams) {
        return $mdToast.show(
            $mdToast.simple()
                .textContent(translation)
                .position("bottom right")
                .hideDelay(10000)
                .action(actionName)
                .theme($workspaceIdHolder.themeWorldTheme.value ? $workspaceIdHolder.themeWorldTheme.value :
                        $workspaceIdHolder.currentWorkspaceId.value + $workspaceIdHolder.suffixForTheme.value)
                .highlightAction(true)
                .highlightClass("md-accent")
        ).then(function (response) {
            if (response === 'ok') {
                if (angular.isFunction(actionFunc)) {
                    if (actionParams) {
                        actionFunc(actionParams);
                    }
                    else {
                        actionFunc();
                    }
                }
            }
            else {
                if (angular.isFunction(hideFunc)) {
                    hideFunc();
                }
            }
        });
    };

    this.openUploadToast = function () {
        uploadProgress = 0;
        this.uploadToastPromise = $mdToast.show({
            templateUrl: 'shared/toast/templates/upload-toast.tmpl.html',
            controller: 'UploadToastCtrl',
            controllerAs: 'uploadToastCtrl',
            hideDelay: false,
            autoWrap: true,
            position: "bottom right"
        });

        return this.uploadToastPromise;
    };

    this.setUploadProgress = function (progress) {
        uploadProgress = progress;
    };

    this.getUploadProgress = function () {
        return uploadProgress;
    };
    /**
     * Hide an existing toast and resolve the promise returned from $mdToast.show().
     *
     * @param response an argument for the resolved promise
     * @return
     */
    this.hideExistingToast = function (response) {
        return $mdToast.hide(response);
    };
}